import { LINK_KEY_SUFFIX } from "constants/booksHandoff";

export const getLinkKey = (fieldKey: string): string =>
  `${fieldKey}${LINK_KEY_SUFFIX}`;
